import axios from 'axios';
import { useEffect } from 'react';
import { useMutation } from 'react-query';

export type VerifyEmailProps = {
  verificationCode?: string;
  spaceCode?: string;
  onMutate?: () => void;
};

export const useVerifyEmail = ({
  verificationCode,
  spaceCode,
  onMutate,
}: VerifyEmailProps) => {
  const mutation = useMutation<void, Error, VerifyEmailProps>(
    (data) => axios.post('signup/verify/email', data),
    {
      onMutate,
    }
  );

  const { mutate } = mutation;

  useEffect(() => {
    if (verificationCode && spaceCode) {
      mutate({ spaceCode, verificationCode });
    }
  }, [verificationCode, spaceCode, mutate]);

  return mutation;
};
